import type {Content} from '@prismicio/client'
import type {SliceComponentProps} from '@prismicio/react'
import type {Context} from 'src/common/types'
import {ContainedImageVariation} from './ContainedImageVariation'
import {FacepileVariation} from './Facepile'
import {FullWidthVariation} from './FullWidthVariation'
import {OldVariations} from './OldVariations'
import {SmallVariation} from './SmallVariation'

/**
 * Props for `CtaV2`.
 */
export type CtaV2Props = SliceComponentProps<Content.CtaV2Slice> & {context: Context}

/**
 * Component for "CtaV2" Slices.
 */
const CtaV2 = (props: CtaV2Props): JSX.Element => {
  const {slice, context, index} = props

  switch (slice.variation) {
    case 'fullWidthImage':
      return (
        <FullWidthVariation
          slice={slice}
          pageUid={context.pageUid}
          componentIndex={index}
          buttonsData={context.buttonsData}
        />
      )
    case 'small':
      return <SmallVariation slice={slice} index={index} context={context} />
    case 'containedImage':
      return <ContainedImageVariation slice={slice} index={index} context={context} />
    case 'facepile':
      return <FacepileVariation slice={slice} index={index} context={context} />
    default:
      return (
        <OldVariations
          slice={slice}
          pageUid={context.pageUid}
          componentIndex={index}
          buttonsData={context.buttonsData}
          fallbackImage={context.mainImage}
        />
      )
  }
}

export default CtaV2
